/* @flow */
import messages from '../l10n/coachmarkL10n';
import type { StepDefault, Config } from '../type/tourType';
import { profileRoute } from 'src/shared/app/base/route/setting/routeSettings';

export const TOUR_SELECTOR_KEYS = {
  TOPIC_CARD: 'topicCardTour',
  CREATE_TOPIC_BUTTON: 'createTopicButtonTour',
  PEOPLETAB: 'peopleTabTour',
  PEOPLE_CARD: 'peopleCardTour',
  CONNECT_INTEREST: 'peopleCardConnectButtonTour',
  PROFILE_BUTTON: 'profileButtonTour',
  TOPIC_TYPE: 'topicTypeTour',
  TOPIC_BOOK_BUTTON: 'topicBookTour',
  BRAINDATE_SECTION_TITLE: 'braindateSectionTitleTour',
  BRAINDATE_UPCOMING_TAB: 'braindateUpcomingTabTour',
  OPTION_DROPDOWN_MENU: 'braindateDropdownMenuTour',
};

const TOUR_CONFIG_KEYS = {
  MARKET_TOPICS: 'marketTopics',
  MARKET_PEOPLES: 'marketPeoples',
  TOPIC_ONE: 'topicOne',
  TOPIC_GROUP: 'topicGroup',
  TOPIC_FISHBOWL: 'topicFishbowl',
  BRAINDATE_PENDING: 'braindatePending',
  BRAINDATE_UPCOMING: 'braindateUpcoming',
  BRAINDATE_PAST: 'braindatePast',
};

export const toursDefaultStep: StepDefault = {
  disableBeacon: true,
};

export const tours: Config = {
  marketTopics: {
    key: TOUR_CONFIG_KEYS.MARKET_TOPICS,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_CARD,
        title: messages.marketStep1Title,
        content: messages.marketStep1Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_CARD,
        title: messages.marketStep2Title,
        content: messages.marketStep2Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.CREATE_TOPIC_BUTTON,
        title: messages.marketStep3Title,
        content: messages.marketStep3Content,
        placement: 'bottom',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.PEOPLETAB,
        title: messages.marketStep4Title,
        content: messages.marketStep4Content,
        placement: 'bottom',
      },
    ],
  },
  marketPeoples: ({ isInterestBasedBraindatingEnabled }) => ({
    key: TOUR_CONFIG_KEYS.MARKET_PEOPLES,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.PEOPLE_CARD,
        title: messages.peopleStep1Title,
        content: messages.peopleStep1Content,
        placement: 'right',
      },
      isInterestBasedBraindatingEnabled
        ? {
            targetClassname: TOUR_SELECTOR_KEYS.CONNECT_INTEREST,
            title: messages.peopleStep2Title,
            content: messages.peopleStep2Content,
            placement: 'right',
          }
        : null,
      {
        targetClassname: TOUR_SELECTOR_KEYS.PROFILE_BUTTON,
        title: messages.peopleStep3Title,
        content: messages.peopleStep3Content,
        secondaryAction: messages.peopleStep3SecondaryAction,
        // Must be a function because of a circular deps with routeSettings
        secondaryActionRoute: () => profileRoute,
        placement: 'bottom',
      },
    ].filter(Boolean),
  }),
  topicOne: {
    key: TOUR_CONFIG_KEYS.TOPIC_ONE,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_TYPE,
        title: messages.topicOneStep1Title,
        content: messages.topicOneStep1Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_BOOK_BUTTON,
        title: messages.topicOneStep2Title,
        content: messages.topicOneStep2Content,
        placement: 'right',
      },
    ],
  },
  topicGroup: {
    key: TOUR_CONFIG_KEYS.TOPIC_GROUP,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_TYPE,
        title: messages.topicGroupStep1Title,
        content: messages.topicGroupStep1Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_BOOK_BUTTON,
        title: messages.topicGroupStep2Title,
        content: messages.topicGroupStep2Content,
        placement: 'right',
      },
    ],
  },
  topicFishbowl: {
    key: TOUR_CONFIG_KEYS.TOPIC_FISHBOWL,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_TYPE,
        title: messages.topicFishbowlStep1Title,
        content: messages.topicFishbowlStep1Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.TOPIC_BOOK_BUTTON,
        title: messages.topicFishbowlStep2Title,
        content: messages.topicFishbowlStep2Content,
        placement: 'right',
      },
    ],
  },

  braindatePending: {
    key: TOUR_CONFIG_KEYS.BRAINDATE_PENDING,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.BRAINDATE_SECTION_TITLE,
        title: messages.braindatePendingStep1Title,
        content: messages.braindatePendingStep1Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.BRAINDATE_UPCOMING_TAB,
        title: messages.braindatePendingStep2Title,
        content: messages.braindatePendingStep2Content,
        placement: 'right',
      },
    ],
  },

  braindateUpcoming: {
    key: TOUR_CONFIG_KEYS.BRAINDATE_UPCOMING,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.BRAINDATE_SECTION_TITLE,
        title: messages.braindateUpcomingStep1Title,
        content: messages.braindateUpcomingStep1Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.OPTION_DROPDOWN_MENU,
        title: messages.braindateUpcomingStep2Title,
        content: messages.braindateUpcomingStep2Content,
        placement: 'right',
      },
    ],
  },

  braindatePast: {
    key: TOUR_CONFIG_KEYS.BRAINDATE_PAST,
    steps: [
      {
        targetClassname: TOUR_SELECTOR_KEYS.BRAINDATE_SECTION_TITLE,
        title: messages.braindatePastStep1Title,
        content: messages.braindatePastStep1Content,
        placement: 'right',
      },
      {
        targetClassname: TOUR_SELECTOR_KEYS.OPTION_DROPDOWN_MENU,
        title: messages.braindatePastStep2Title,
        content: messages.braindatePastStep2Content,
        placement: 'right',
      },
    ],
  },
};
